#@export GliveBooking.Presenters.Section

class GliveBooking.Presenters.Section extends BookingV2.Presenters.Base

  module: 'glive-booking'

  toHash: ->
    title:     @model.getTitle()
    selected:  @options.selected?.getTitle() == @model.getTitle()
